import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
//Farshid
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction, saveAComment, updateUserProfileAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import Image from 'material-ui-image'
import * as MainConstants from "../../utils/MainConstants";

//import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
//import {bindActionCreators} from "redux";
//import {connect} from "react-redux";
//import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//End Farshid



const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)
  
});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    //marginTop: theme.spacing.unit * 3,
    height: '20px',
    color:"#ffffff",
    //backgroundColor:"#760eb3",
  },
  
  multilineColor:{
    color:'black',
    backgroundColor:'#f5f7e8'
  }
});


class PrivatePropertyManagement extends Component {
  
  state = {
    age: '',
    name: 'hai',
    firstname: '',
    lastname:'',
    email:'',
    comment:'',
    userComment:{}
  };
  
  constructor(props) {
    super(props);
    
    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange= this.handleEmailChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.saveVisitorComment = this.saveVisitorComment.bind(this);
    
    
    
  }
  
  
  componentDidMount() {
    const { isAuthenticated ,updateUserProfileAction} = this.props;
    //isAuthenticated();
    //updateUserProfileAction(this.props.userProfile, this.props.loginData.accessToken);
    updateUserProfileAction(null, this.props.loginData.accessToken);
    //updateAuth();
    // console.log("Farshid the loginData " + this.props.loginData.accessToken)  ;
    
  }
  
  
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  
  handleFirstNameChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));
    
    //this.setState({userComment , {{firstname:event.target.value }});
    // this.setState(Object.assign(this.state.firstname, event.target.value));
  }
  
  handleLastNameChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.lastname, event.target.value));
    this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));
    
  }
  
  handleEmailChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.email,event.target.value));
    this.setState(Object.assign(this.state.userComment,{email:event.target.value}));
    
  }
  handleCommentChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
  }
  
  
  saveVisitorComment(){
    const {saveAComment} = this.props;
    var  returnString="";
    var tempLastName =  this.state.userComment.lastname;
    var tempFirstName = this.state.userComment.firstname;
    var tempEmail = this.state.userComment.email;
    var tempComment = this.state.userComment.comment;
    
    
    if((tempFirstName == null) || (tempFirstName.length == 0)){
      alert("Please provide your first name!");
    }else {
      
      if ((tempLastName == null) || (tempLastName.length == 0)) {
        alert("Please provide your last name!");
      }else {
        
        if ((tempEmail == null) || (tempEmail.length == 0)) {
          alert("Please provide your Email!");
        } else {
          
          if ((tempEmail.indexOf("@") == -1)) {
            alert("Please provide proper Email address!");
          }else{
            if ((tempComment == null) || (tempComment.length == 0)) {
              alert("Please provide your comment!");
            }else{
              //Here send the data to the back end.
              saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);
              
            }
          }
        }
      }
    }
    
    return returnString;
  }

//Background color was backgroundColor:'#f4f3ed',
  
  
  render() {
    const { classes } = this.props;
    const MyLink = props => <RouterLink to="#top2" {...props} />
    return (
      
      <div id="top1"  style={{  }}>
        <Grid container spacing={24}>
          
          <Grid   item xs={12} sm={12}  >
            
            
            <div    style = { {  backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat'  }}>
              
              <div style = { {  backgroundPosition:'center',  backgroundSize:'cover', display: 'flex', flexDirection: 'column',alignItems: 'left' ,  backgroundRepeat:'no-repeat'  }}>
                <Typography variant="h3" component="h3" style = { { flex:'1', textAlign: 'center', alignSelf: 'center'  , marginTop:10,  color:'black', fontSize:30}}>
                  {MainConstants.APPLICATION_NAME}&trade;
                </Typography>
                <Typography variant="h3" component="h3" style = { { flex:'1', textAlign: 'center', alignSelf: 'center'  , marginTop:10,  color:'black', fontSize:30}}>
                 For
                </Typography>
                <Typography variant="h7" component="h7" style = { {flex:'1', textAlign: 'center', alignSelf: 'center'  , marginTop:10,  color:'black' ,/*color:'#BF360C',*/ fontSize:40}}>
                  Private Property Management
                </Typography>
                <Typography component="h4" variant="h4"   style = { { textAlign: 'left', alignSelf: 'center'  ,marginTop:0,  color:'#e2580d'}} >
                  ______________________________
                </Typography>
              </div>
              
              {/*}<h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontSize:20}} ></h6>*/}
              
              <div style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      Managing parking on private property shouldn’t be a constant source of complaints, conflicts, and inefficiency.
                      {MainConstants.APPLICATION_NAME}&trade; transforms how property owners, managers, and enforcement teams handle violations—by resolving issues before a tow becomes necessary.</Typography>
                    <br/>
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300', fontWeight:'bold'}}>
                      Turn Towing Into Resolution, Not Conflict
                    </Typography>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                      Traditional towing creates friction:
                      
                      <ul>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Angry tenants and guests</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Time-consuming disputes</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Unnecessary towing logistics</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Reputation damage for property managers</span>
                        </li>
                      </ul>
                      
                      {MainConstants.APPLICATION_NAME}&trade; flips that model.
                      Instead of immediately towing a vehicle, your team can notify the owner in real time, giving them a chance to resolve the violation on the spot.
                    </Typography>
                   
                    <br/>
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300', fontWeight:'bold'}}>
                      How it Works
                    </Typography>
                   
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                      <ol style={ { flexDirection: 'column'}}>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', fontWeight:'bold' , display:'flex'}}> Violation Detected</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' , display:'flex'}}> A tow operator or property staff identifies a parking violation.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' , fontWeight:'bold' , display:'flex'}}> Instant Owner Notification</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' , display:'flex'}}> The vehicle owner receives a real-time alert through {MainConstants.APPLICATION_NAME}&trade;.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', fontWeight:'bold' , display:'flex'}}> On-the-Spot Resolution</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' , display:'flex'}}> The owner can respond immediately—move the vehicle or resolve the issue.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black',fontWeight:'bold' , display:'flex'}}> Digital Enforcement Workflow</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' , display:'flex'}}> If unresolved, the system seamlessly proceeds with towing—fully documented.</span>
                        </li>
                      </ol>
                    </Typography>
                    <br/>
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300', fontWeight:'bold'}}>
                      Key Features for Property Managers
                    </Typography>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                      <ul style={ { flexDirection: 'column'}}>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', fontWeight:'bold', display:'flex'}}> Real-Time Violation Alerts</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', display:'flex'}}> Notify vehicle owners instantly before escalation. Reduce complaints and increase compliance.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' , fontWeight:'bold' ,display:'flex'}}> Digital Enforcement Dashboard</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Track violations, monitor activity, and manage enforcement from a centralized platform.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', fontWeight:'bold' ,display:'flex'}}> Complete Audit Trail</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' ,display:'flex'}}> Every action is logged—timestamps, communications, and outcomes—for full transparency and protection.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black',fontWeight:'bold' ,display:'flex'}}> Custom Property Rules</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' ,display:'flex'}}> Set and enforce property-specific parking policies with flexibility.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black',fontWeight:'bold' ,display:'flex'}}> Integrated Tow Operations</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' ,display:'flex'}}> Seamlessly connect with tow operators when enforcement is required—no manual coordination.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black',fontWeight:'bold' ,display:'flex'}}> On-Site Resolution Payments</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' ,display:'flex'}}> Allow drivers to resolve violations immediately without towing—saving time for everyone.</span>
                        </li>
                      </ul>
                    </Typography>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300', fontWeight:'bold'}}>
                      Why Property Managers Choose {MainConstants.APPLICATION_NAME}&trade;
                    </Typography>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                      <ul style={ { flexDirection: 'column'}}>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', fontWeight:'bold' ,display:'flex'}}> Reduce Tenant Complaints</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' ,display:'flex'}}> Give people a fair warning before towing.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' , fontWeight:'bold' ,display:'flex'}}> Increase Operational Efficiency</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' ,display:'flex'}}> Spend less time managing disputes and logistics.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', fontWeight:'bold' ,display:'flex'}}> Protect Your Property’s Reputation</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' ,display:'flex'}}> Replace confrontation with communication.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black',fontWeight:'bold' ,display:'flex'}}> Lower Unnecessary Tows</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' ,display:'flex'}}> Resolve more violations on-site.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black',fontWeight:'bold' ,display:'flex'}}> Create a Modern Parking Experience</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' ,display:'flex'}}> Bring transparency and technology to enforcement.</span>
                        </li>
                      
                      </ul>
                    </Typography>
                    <br/>
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300', fontWeight:'bold'}}>
                      Built for Modern Properties
                    </Typography>
                    <br/>
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300' }}>
                      {MainConstants.APPLICATION_NAME}&trade; is ideal for:
                    </Typography>
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                      <ul>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', fontWeight:'bold'}}></span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>  Apartment complexes </span>
                        
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' , fontWeight:'bold'}}> </span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> HOAs and residential communities</span>
                        
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', fontWeight:'bold'}}> </span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Commercial properties</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black',fontWeight:'bold'}}> </span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Retail centers</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black',fontWeight:'bold'}}> </span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Office parks</span>
                        </li>
                      
                      </ul>
                    </Typography>
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300', fontWeight:'bold'}}>
                      A Smarter Approach to Parking Enforcement
                    </Typography>
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300' }}>
                      {MainConstants.APPLICATION_NAME}&trade; doesn’t just enforce rules—it creates a better system for everyone involved.
                    </Typography>
                    <br/>
                    <Typography variant="h5" component="h5" style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'300', marginBottom:'100', width:'300',   fontSize:'600' }}>
                      Less conflict, More compliance, Better outcomes
                    </Typography>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300', color:'red'}}>
                    </Typography>
                    <br/>
                    <div style={{paddingLeft:10, paddingBottom:20, display: 'flex', alignSelf:'center' ,flexDirection: 'column', justifyCenter: 'center' }}>
                      <a href="/hoas"   rel="noreferrer" style={{ paddingLeft:0, paddingBottom:20, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <Typography component="h5" variant="h5" style = { { color:'blue' }} >
                          HOAs (Homeowners Associations)
                        </Typography>
                      </a>
                      <a href="/apartment"   rel="noreferrer" style={{  paddingLeft:0, paddingBottom:20, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <Typography component="h5" variant="h5" style = { { color:'blue'}} >
                          Apartment Complexes / Property Managers
                        </Typography>
                      </a>
                      <a href="/campus"   rel="noreferrer" style={{ paddingLeft:0, paddingBottom:20, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <Typography component="h5" variant="h5" style = { { color:'blue'}} >
                          Campuses (Universities / Colleges)
                        </Typography>
                      </a>
                    </div>
                    
                    <br/>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
              </div>
              <br/>
            </div>
          </Grid>
        </Grid>
      </div>
    
    
    
    );
  }
}

PrivatePropertyManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticatedBool: state.login.isAuthenticatedBool,
    userProfile: state.login.userProfile,
    loginData:state.login.loginData,
    
    //auth:state.login.loginData,
    //CompanyDeleteResponse:state.account.deleteCompanyResp,
    //CompanySaveResponse:state.account.saveCompanyResp,
    //locationsArray:state.location.locationsArray,
    //vcArray:state.videocontroller.vcArray,
    //camerasArray:state.camera.camerasArray,
    //errorCMsg:state.account.errorCMsg,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    //login:login,
    //handleAuthentication:handleAuthentication,
    //isAuthenticated:isAuthenticated,
    updateUserProfileAction:updateUserProfileAction,
    saveAComment:saveAComment,
    //updateAuth:updateAuth,
    
  }, dispatch);
};

//export default BiomassView;
//export default withStyles(styles)(AboutPlateWiz);




//export default withStyles(styles)(AppView);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PrivatePropertyManagement));
